import * as React from 'react';
import { LiveOrdersData } from '../../models/LiveOrders';
import { useTranslation } from 'react-i18next';
import { Box, Card, CardContent, styled } from '@mui/material';
import { CountryNameDisplay } from '../shared/CountryNameDisplay';

const StyledContentContainer = styled('div')(() => ({
    display: 'flex',
    width: '100%',
    gap: '10px',
}));

const StyledContent = styled('div')(() => ({
    flex: '1 1 auto',
}));

const StyledBox = styled('div')(() => ({
    paddingBottom: '10px',
}));

const StyledBoxTitle = styled('div')(() => ({
    color: 'rgb(112,112,112)',
    paddingBottom: '5px',
}));
export const LiveOrdersDetailsWrapper: React.FC<{
    liveOrder: LiveOrdersData;
}> = (props) => {
    const { liveOrder } = props;

    const { t } = useTranslation('liveOrders', {
        keyPrefix: 'LIVE_ORDER_DETAILS.ORDER',
    });

    const getBillingAddress = (): string => {
        return (
            liveOrder.sellToCustomerPublicPlaceName +
            ' ' +
            liveOrder.sellToCustomerPublicPlaceType +
            ' ' +
            liveOrder.sellToCustomerHouseNo
        );
    };

    return (
        <>
            <Card sx={{ minWidth: 275 }}>
                <CardContent>
                    <StyledContentContainer>
                        <StyledContent>
                            <StyledBox>
                                <StyledBoxTitle>{t('CONTACT')}</StyledBoxTitle>
                                <Box>{liveOrder.sellToCustomerContactName}</Box>
                                <Box>{liveOrder.sellToCustomerEmail}</Box>
                            </StyledBox>
                            <StyledBox>
                                <StyledBoxTitle>
                                    {t('COMPANY_NAME')}
                                </StyledBoxTitle>
                                <Box>{liveOrder.sellToCustomerName}</Box>
                            </StyledBox>
                            <StyledBox>
                                <StyledBoxTitle>
                                    {t('ORDER_DETAILS')}
                                </StyledBoxTitle>
                                <Box>
                                    {t('ORDER_ID')}: {liveOrder.orderNo}
                                </Box>
                                <Box>
                                    {t('DATE')}: {liveOrder.orderDate}
                                </Box>
                            </StyledBox>
                        </StyledContent>
                        <StyledContent>
                            <StyledBox>
                                <StyledBoxTitle>{t('SHIPPING')}</StyledBoxTitle>
                                <Box>
                                    {liveOrder.shipToPostCode}{' '}
                                    {liveOrder.shipToCity}
                                </Box>
                                <Box>{liveOrder.shipToAddress}</Box>
                                <Box>{liveOrder.shipToAddress2}</Box>
                                <Box>
                                    <CountryNameDisplay
                                        countryCode={
                                            liveOrder.shipToCountryCode
                                        }
                                    />
                                </Box>
                                <Box>{liveOrder.shipToPhoneNo}</Box>
                            </StyledBox>
                            <StyledBox>
                                <StyledBoxTitle>
                                    {t('SHIPPING_METHOD')}
                                </StyledBoxTitle>
                                <Box>{liveOrder.shippingMethod}</Box>
                            </StyledBox>
                        </StyledContent>
                        <StyledContent>
                            <StyledBox>
                                <StyledBoxTitle>{t('BILLING')}</StyledBoxTitle>
                                <Box>
                                    <Box>
                                        {liveOrder.sellToCustomerPostCode}{' '}
                                        {liveOrder.sellToCustomerCity}
                                    </Box>
                                    <Box>{getBillingAddress()}</Box>
                                    {liveOrder.sellToCustomerCountryCode && (
                                        <Box>
                                            <CountryNameDisplay
                                                countryCode={
                                                    liveOrder.sellToCustomerCountryCode
                                                }
                                            />
                                        </Box>
                                    )}
                                </Box>
                            </StyledBox>
                        </StyledContent>
                    </StyledContentContainer>
                </CardContent>
            </Card>
        </>
    );
};
